import { PercentageDepositRoundingModeEnum } from '../enums/percentage-deposit-rounding-mode.enum';
import { PercentageDepositRoundingConfig } from '../interfaces/percentage-deposit-rounding-config.interface';

/**
 * Seed / fallback / ops-disable default for reservationPercentageDepositRounding.
 */
export const DEFAULT_PERCENTAGE_DEPOSIT_ROUNDING: PercentageDepositRoundingConfig =
  {
    isEnabled: false,
    increment: 5,
    mode: PercentageDepositRoundingModeEnum.NEAREST,
  };
